module.exports = __webpack_public_path__ + "static/media/vdwf.eb0c8bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/vdwf.png
// module id = 404
// module chunks = 0